"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postGQL = exports.GQLquery = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _network = require("@adobe/exc-app/network");

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
var GQLquery = "\n  query preferencePageDataQuery($imsOrgId: String, $imsUserId: String) {\n    userOrgPreferences(imsOrgId: $imsOrgId, imsUserId: $imsUserId) {\n        displayAlert\n    }\n  }\n";
/**
 * It will make the GQL call to preferences data on org switch.
 *
 * @param variables
 * @param isFallback
 */

exports.GQLquery = GQLquery;

var postGQL =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee() {
    var variables,
        isFallback,
        resp,
        _args = arguments;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            variables = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            isFallback = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
            _context.prev = 2;
            _context.next = 5;
            return (0, _network.query)({
              data: {
                query: GQLquery,
                variables: variables
              },
              operationName: 'preferencePageDataQuery'
            });

          case 5:
            resp = _context.sent;

            if (!resp.ok) {
              _context.next = 12;
              break;
            }

            _context.next = 9;
            return resp.json();

          case 9:
            return _context.abrupt("return", _context.sent);

          case 12:
            throw Error("Failed in Graphql Service - ".concat(resp));

          case 13:
            _context.next = 22;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](2);

            if (isFallback) {
              _context.next = 21;
              break;
            }

            _context.next = 20;
            return postGQL(variables, true);

          case 20:
            return _context.abrupt("return", _context.sent);

          case 21:
            return _context.abrupt("return", Promise.reject(_context.t0));

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 15]]);
  }));

  return function postGQL() {
    return _ref.apply(this, arguments);
  };
}();

exports.postGQL = postGQL;